import request from '@/router/axios'
import env from '@/config/env'

// 抽奖活动列表
export function rafflePage(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/page',
    method: 'post',
    data
  })
}

// 新增抽奖活动
export function raffleCreate(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/create',
    method: 'post',
    data
  })
}
// 编辑抽奖活动
export function raffleUpdate(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/update',
    method: 'post',
    data
  })
}
// 抽奖活动详情
export function raffleDetail(id) {
  return request({
    url: env.ferryUrl + `/activitiyRaffle/${id}`,
    //   url: `http://192.168.31.207:37579/activitiyRaffle/${id}`,
    method: 'get'
  })
}

// 全部奖品列表
export function prizeList(params) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/prizes/all',
    method: 'get',
    params
  })
}

// 抽奖活动奖品列表
export function activePrizeList(activityId) {
  return request({
    url: env.ferryUrl + `/activitiyRaffle/activity/prizes/${activityId}`,
    method: 'get'
  })
}

// 抽奖活动数据
export function prizeStatistics(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/activity/data/baseDeatils',
    method: 'post',
    data
  })
}

// 抽奖活动用户参与数据
export function userPrizeRecord(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/activity/data/userDetails',
    method: 'post',
    data
  })
}
// 奖品设置-新增奖品
export function prizeAdd(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/activity/prizes/add',
    method: 'post',
    data
  })
}
// 奖品设置-编辑奖品
export function prizeUpdate(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/activity/prizes/update',
    method: 'post',
    data
  })
}
// 奖品设置-删除奖品
export function prizeDel(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/activity/prizes/delete',
    method: 'delete',
    data
  })
}
// 奖品池-管理分页页面
export function prizepage(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/prizes/page',
    method: 'post',
    data
  })
}

// 抽奖预览
export function preview(id) {
  return request({
    url: env.ferryUrl + `/activitiyRaffle/preview/${id}`,
    method: 'get'
  })
}
// 预览--中奖名单
export function winnerList(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/preview/winner-list',
    method: 'post',
    data
  })
}
// 设置中奖名单
export function fakeWinner(data) {
  return request({
    url: env.ferryUrl + '/activitiyRaffle/fakeWinner/add',
    method: 'post',
    data
  })
}

// 改变活动状态
export function activeStatus(data) {
    return request({
      url: env.ferryUrl + '/activitiyRaffle/status/update',
      method: 'post',
      data
    })
  }
